/** TODO: Delete when migrating apply */
import React from 'react';
import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';

const InputBankAccountType = ({ name = 'accountType' }) => (
  <ValidatedTextField
    name={name}
    control={useFormContext().control}
    rules={{ required: 'This field is required.' }}
  >
    <TextField
      fullWidth
      label="Account Type"
      select
      SelectProps={{ native: true }}
    >
      <option value="" disabled aria-label="blank option" />
      <option value="Checking">Checking</option>
      <option value="Savings">Savings</option>
    </TextField>
  </ValidatedTextField>
);

export default InputBankAccountType;
